export const displayValues: Record<string, string> = {
  block: "block", "inline-block": "inline-block", inline: "inline",
  flex: "flex", "inline-flex": "inline-flex", grid: "grid",
  "inline-grid": "inline-grid", hidden: "none", table: "table",
  "table-cell": "table-cell", "table-row": "table-row",
  "flow-root": "flow-root", contents: "contents",
};

export const positionValues: Record<string, string> = {
  static: "static", relative: "relative", absolute: "absolute",
  fixed: "fixed", sticky: "sticky",
};

export const overflowValues: Record<string, string> = {
  auto: "auto", hidden: "hidden", visible: "visible",
  scroll: "scroll", clip: "clip",
};

export const zIndexScale: Record<string, string> = {
  "0": "0", "10": "10", "20": "20", "30": "30",
  "40": "40", "50": "50", auto: "auto",
};

export const floatValues: Record<string, string> = {
  left: "left", right: "right", none: "none",
};

export const clearValues: Record<string, string> = {
  left: "left", right: "right", both: "both", none: "none",
};

export const boxSizingValues: Record<string, string> = {
  border: "border-box", content: "content-box",
};
